import $axios from "../../api";

// P26_048 Penulis (menu Articles > Penulis). Endpoint: ArticleAuthorController.
const PREFIX = "website/article-author";

const state = {
    isLoading: false,
    createLoading: false,
    errors: "",
    isSuccess: false,
    list: [],
    page: 1,
    detail: null,
};

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    SET_ERRORS(state, payload) {
        state.errors = payload;
    },
    // Drop the messages of fields the user just changed; the rest stay until the next save.
    CLEAR_ERRORS(state, fields) {
        if (!state.errors || typeof state.errors !== "object") return;
        const next = { ...state.errors };
        (fields || []).forEach((field) => delete next[field]);
        state.errors = next;
    },
    SET_SUCCESS(state, payload) {
        state.isSuccess = payload;
    },
    SET_LIST(state, payload) {
        state.list = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    SET_CREATE_LOAD(state, payload) {
        state.createLoading = payload;
    },
    SET_DETAIL(state, payload) {
        state.detail = payload;
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return $axios
            .get(`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
            .then((response) => commit("SET_LIST", response.data.data))
            .catch((error) => dispatch("Main/globalSweetAlert", error.response, { root: true }))
            .finally(() => commit("SET_LOADING", false));
    },
    getDetail({ commit, dispatch }, id) {
        commit("SET_LOADING", true);
        commit("SET_DETAIL", null);
        return $axios
            .get(`${PREFIX}/view?id=${id}`)
            .then((res) => commit("SET_DETAIL", res.data.data))
            .catch((error) => dispatch("Main/globalSweetAlert", error.response, { root: true }))
            .finally(() => commit("SET_LOADING", false));
    },
    // Resolves with the server message on success (it says how many articles a rename reached);
    // field errors (422) go to state.errors and appear under each input.
    saveData({ commit, dispatch }, { isUpdate, payload }) {
        commit("SET_SUCCESS", false);
        commit("SET_ERRORS", "");
        commit("SET_CREATE_LOAD", true);
        return $axios
            .post(`${PREFIX}/${isUpdate ? "update" : "create"}`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                return response.data;
            })
            .catch((error) => {
                if (error.response?.status === 422 && error.response.data?.errors) {
                    commit("SET_ERRORS", error.response.data.errors);
                } else {
                    dispatch("Main/globalSweetAlert", error.response, { root: true });
                }
                throw error;
            })
            .finally(() => commit("SET_CREATE_LOAD", false));
    },
    showHide({ commit, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        return $axios
            .post(`${PREFIX}/showhide`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                dispatch("Main/globalSuccessSweetAlert", response.data.message, { root: true });
            })
            .catch((error) => dispatch("Main/globalSweetAlert", error.response, { root: true }));
    },
    // Refused with 422 while articles still carry the author's name.
    deleteData({ commit, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        return $axios
            .post(`${PREFIX}/delete`, payload)
            .then((response) => {
                commit("SET_SUCCESS", true);
                dispatch("Main/globalSuccessSweetAlert", response.data.message, { root: true });
            })
            .catch((error) => dispatch("Main/globalSweetAlert", error.response, { root: true }));
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
